import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import auth from '../modules/Auth/reducers'
import autocomplete from '../modules/Autocomplete/reducers'
import buque from '../modules/Buque/reducers'
import calado from '../modules/Calado/reducers'
import camionesIngreso from '../modules/Camiones/reducers'
import cereal from '../modules/Cereal/reducers'
import cuadroDeMandoMovimientos from '../modules/CuadroDeMandoMovimientos/reducers'
import cupos from '../modules/Cupos/reducers'
import dashboard from '../modules/Dashboard/reducers'
import datepicker from '../modules/DatePicker/reducers'
import dialogs from '../modules/Forms/SharedComponents/containers/Dialog/reducers'
import embarque from '../modules/Embarque/reducers'
import toasts from '../modules/Forms/SharedComponents/containers/Toast/reducers'
import motivosAbandono from '../modules/MotivosAbandono/reducers'
import motivosRechazo from '../modules/MotivosRechazo/reducers'
import { reducerGraficoSilos } from '../modules/Movimiento/abmMovimientos/graficoSilos/reducers/GraficoSilosReducer'
import { movimientosReducer } from '../modules/Movimiento/reducers/movimiento'
import { reducerFiltroReporteParaEmbarque } from '../modules/Movimiento/reporteParaEmbarque/reducer/embarqueReducer'
import { reducerDropdown } from '../modules/Movimiento/shared/dropDownEtiqueta/reducer/DropdownReducer'
import { reducerDropdownParaFiltroReporteParaEmbarque } from '../modules/Movimiento/shared/filtroCerealCerealVariedadYEtiqueta/reducer/filtroCerealCerealVariedadYEtiquetaReducer'
import { pdfDownloadLinkReporteLaridaeReducer } from '../modules/Movimiento/shared/pdfDownloadLinkReporteLaridae/reducer/pdfDownloadLinkReporteLaridaeReducer'
import muitable from '../modules/MuiTable/reducers'
import pdfDownload from '../modules/PdfDownload/reducers'
import pesado from '../modules/Pesado/reducers'
import printer from '../modules/Printer/reducers'
import puestoCalado from '../modules/PuestoCaladoPicker/reducers'
import sideBar from '../modules/SideBar/reducers'
import stock from '../modules/Stock/reducers'
import utils from '../modules/Utils/reducers'
import vista3d from '../modules/Vista3d/reducers'
import volcadora from '../modules/Volcadora/reducers'
import pais from '../modules/Pais/reducers'
import cartaDePorte from '../modules/CartaDePorte/reducers'
import entregadores from '../modules/Entregadores/reducers'
import huella from '../modules/Huella/reducers'
import caladosRechazados from '../modules/Camiones/containers/listados/camionesRechazadosEnCalado/reducers'
import camionesSinDefinitiva from '../modules/Movimiento/TablasSinAsignar/camionesSinDefinitiva/reducers'
import movimientosMercaderia from '../modules/Movimiento/TablasSinAsignar/movimientosMercaderia/reducers'
import comunicacionEmbarque from '../modules/ComunicacionEmbarque/reducers'
import mensajeria from '../modules/Mensajeria/reducers'

// import { connectRouter } from 'connected-react-router'
// import reporteEstadoPorSilo from '../modules/ReporteEstadoPorSilo/reducers';
const appMainReducer = combineReducers({
  routing,
  form: formReducer,
  camionesIngreso,
  auth,
  autocomplete,
  buque,
  cereal,
  datepicker,
  sideBar,
  printer,
  motivosAbandono,
  motivosRechazo,
  puestoCalado,
  calado,
  embarque,
  pesado,
  dashboard,
  stock,
  muitable,
  cupos,
  dialogs,
  toasts,
  cuadroDeMandoMovimientos,
  utils,
  vista3d,
  volcadora,
  pais,
  cartaDePorte,
  entregadores,
  huella,
  caladosRechazados,
  camionesSinDefinitiva,
  movimientosMercaderia,
  comunicacionEmbarque,
  estadoGraficoSilos: reducerGraficoSilos,
  versionLaridae: pdfDownloadLinkReporteLaridaeReducer,
  movimientos: movimientosReducer,
  mensajeria,
  pdfDownload,
  dropdownEtiqueta: reducerDropdown,
  filtroCerealCerealVariedadEtiquetas: reducerDropdownParaFiltroReporteParaEmbarque,
  filtrosParaEmbarque: reducerFiltroReporteParaEmbarque

})

export default appMainReducer
